import { defineComponent as v, watchEffect as f, h as t } from "vue";
import { useCalendarProps as m, useCalendar as $ } from "./ghl-ui.es1342.js";
import k from "./ghl-ui.es1343.js";
import { warnOnce as y } from "./ghl-ui.es853.js";
import { resolveSlot as d } from "./ghl-ui.es860.js";
import C from "./ghl-ui.es1069.js";
import _ from "./ghl-ui.es1067.js";
import w from "./ghl-ui.es1066.js";
import x from "./ghl-ui.es1068.js";
import p, { XButton as O } from "./ghl-ui.es253.js";
import g from "./ghl-ui.es1147.js";
const V = v({
  name: "DatePanel",
  props: Object.assign(Object.assign({}, m), {
    type: {
      type: String,
      required: !0
    }
  }),
  setup(n) {
    return process.env.NODE_ENV !== "production" && f(() => {
      var l;
      !((l = n.actions) === null || l === void 0) && l.includes("confirm") && y("date-picker", "The `confirm` action is not supported for n-date-picker of `date` type");
    }), $(n, n.type);
  },
  render() {
    var n, l, c;
    const {
      mergedClsPrefix: e,
      mergedTheme: o,
      shortcuts: r,
      onRender: h,
      $slots: i,
      type: u
    } = this;
    return h == null || h(), t("div", {
      ref: "selfRef",
      tabindex: 0,
      class: [`${e}-date-panel`, `${e}-date-panel--${u}`, !this.panel && `${e}-date-panel--shadow`, this.themeClass],
      onFocus: this.handlePanelFocus,
      onKeydown: this.handlePanelKeyDown
    }, t("div", {
      class: `${e}-date-panel-calendar`
    }, t("div", {
      class: `${e}-date-panel-month`
    }, t("div", {
      class: `${e}-date-panel-month__fast-prev`,
      onClick: this.prevYear
    }, d(i["prev-year"], () => [t(C, null)])), t("div", {
      class: `${e}-date-panel-month__prev`,
      onClick: this.prevMonth
    }, d(i["prev-month"], () => [t(_, null)])), t(k, {
      monthBeforeYear: this.locale.monthBeforeYear,
      value: this.calendarValue,
      onUpdateValue: this.onUpdateCalendarValue,
      mergedClsPrefix: e,
      calendarMonth: this.calendarMonth,
      calendarYear: this.calendarYear
    }), t("div", {
      class: `${e}-date-panel-month__next`,
      onClick: this.nextMonth
    }, d(i["next-month"], () => [t(w, null)])), t("div", {
      class: `${e}-date-panel-month__fast-next`,
      onClick: this.nextYear
    }, d(i["next-year"], () => [t(x, null)]))), t("div", {
      class: `${e}-date-panel-weekdays`
    }, this.weekdays.map((a) => t("div", {
      key: a,
      class: `${e}-date-panel-weekdays__day`
    }, a))), t("div", {
      class: `${e}-date-panel-dates`
    }, this.dateArray.map((a, s) => t("div", {
      "data-n-date": !0,
      key: s,
      class: [`${e}-date-panel-date`, {
        [`${e}-date-panel-date--current`]: a.isCurrentDate,
        [`${e}-date-panel-date--selected`]: a.selected,
        [`${e}-date-panel-date--excluded`]: !a.inCurrentMonth,
        [`${e}-date-panel-date--disabled`]: this.mergedIsDateDisabled(a.ts, {
          type: "date",
          year: a.dateObject.year,
          month: a.dateObject.month,
          date: a.dateObject.date
        }),
        [`${e}-date-panel-date--week-hovered`]: this.isWeekHovered(a),
        [`${e}-date-panel-date--week-selected`]: a.inSelectedWeek
      }],
      onClick: () => {
        this.handleDateClick(a);
      },
      onMouseenter: () => {
        this.handleDateMouseEnter(a);
      }
    }, t("div", {
      class: `${e}-date-panel-date__trigger`
    }), a.dateObject.date, a.isCurrentDate ? t("div", {
      class: `${e}-date-panel-date__sup`
    }) : null)))), this.datePickerSlots.footer ? t("div", {
      class: `${e}-date-panel-footer`
    }, this.datePickerSlots.footer()) : null, !((n = this.actions) === null || n === void 0) && n.length || r ? t("div", {
      class: `${e}-date-panel-actions`
    }, t("div", {
      class: `${e}-date-panel-actions__prefix`
    }, r && Object.keys(r).map((a) => {
      const s = r[a];
      return Array.isArray(s) ? null : t(O, {
        size: "tiny",
        onMouseenter: () => {
          this.handleSingleShortcutMouseenter(s);
        },
        onClick: () => {
          this.handleSingleShortcutClick(s);
        },
        onMouseleave: () => {
          this.handleShortcutMouseleave();
        }
      }, {
        default: () => a
      });
    })), t("div", {
      class: `${e}-date-panel-actions__suffix`
    }, !((l = this.actions) === null || l === void 0) && l.includes("clear") ? t(p, {
      theme: o.peers.Button,
      themeOverrides: o.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleClearClick
    }, {
      default: () => this.locale.clear
    }) : null, !((c = this.actions) === null || c === void 0) && c.includes("now") ? t(p, {
      theme: o.peers.Button,
      themeOverrides: o.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleNowClick
    }, {
      default: () => this.locale.now
    }) : null)) : null, t(g, {
      onFocus: this.handleFocusDetectorFocus
    }));
  }
});
export {
  V as default
};
